import './target.less';
import React from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray } from 'redux-form';
import cn from 'classname';
import find from 'lodash/find';
import get from 'lodash/get';
import isNull from 'lodash/isNull';

import SelectField from '../../../../../shared/form-elements/select/field';
import InputField from  '../../../../../shared/form-elements/input';
import CheckboxField from '../../../../../shared/form-elements/checkbox';

const isRocket = process.env.CPA_ENV === 'rocket';

const propTypes = {
	intl: PropTypes.func,
	onTermsResetToDefault: PropTypes.func,
	offer: PropTypes.array,
	fields: PropTypes.object,
	defaultTerms: PropTypes.object,
	parentIndex: PropTypes.any,
	nullifiedBoosts: PropTypes.array,
	isMaster: PropTypes.bool,
	indTermsNullifyBoostOnSubmit: PropTypes.func
};

class CampaignPayouts extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isVisible: false
		};
	}
	render() {
		const {fields, offerId, payoutCurrencies, defaultTermsByOffer, removeCampaignPayout } = this.props;
		const targets = defaultTermsByOffer && defaultTermsByOffer.targets;

		return (
			<td colSpan="6" className="location__campaigns">
				{
					<button
						onClick={(e) => {
							e.preventDefault();
							e.stopPropagation();
							this.setState(st => ({isVisible: !st.isVisible}));
						}}
						className="toggle-button"
					>
						{this.state.isVisible ? '-' : '+'}
					</button>
				}
				{fields.map((camp_payout, idx) => (
					<div key={idx} className="campaign-params">
						<Field
							name={`${camp_payout}.campaign_title`}
							component={InputField}
							placeholder={'Campaign title'}
							className="campaign_title"
							showLabel={true}
							disabled={true}
						/>
						<Field
							name={`${camp_payout}.campaign_id`}
							component={InputField}
							className="campaign_id"
							placeholder={'Campaign id'}
							showLabel={true}
							disabled={true}
						/>
						<Field
							name={`${camp_payout}.campaign_lang`}
							component={InputField}
							className="campaign_lang"
							disabled={true}
							placeholder={'Language'}
							showLabel={true}
						/>
						<Field
							name={`${camp_payout}.space_title`}
							component={InputField}
							disabled={true}
							placeholder={'Source'}
							showLabel={true}
						/>
						{
							payoutCurrencies.map((currency, index) => {
								const campPayout = fields.get(idx);
								const baseAmount = targets && targets
									.find(trgt => trgt.offer_id === campPayout.offer_id);

								const BiggerThenClass = campPayout
									&& baseAmount
									&& campPayout[currency + '_amount'] > baseAmount[currency]
									? 'bigger-then-base': '';
								const LessThenBaseClass = campPayout
									&& baseAmount
									&& campPayout[currency + '_amount'] < baseAmount[currency]
									? 'less-then-base': '';

								return <div key={index}>
									<Field
										name={`${camp_payout}.${currency}_amount`}
										placeholder={`Payout, ${currency}`}
										className={`payout ${BiggerThenClass} ${LessThenBaseClass}`}
										showLabel={true}
										component={InputField}
									/>
								</div>;
							})
						}
						<span
							onClick={e => {
								e.preventDefault();
								e.stopPropagation();
								if (confirm(
									'Do you realy want to delete campaign payout for ' +
                  JSON.stringify(fields.get(idx).campaign_title)
								)) {
									return removeCampaignPayout(fields.get(idx))
										.then(() => fields.remove(idx));
								}
							}}
							className="delete-camp_payout"
						>
						</span>
					</div>
				))}
				{
					this.state.isVisible &&
						<button
							className="ui-btn ui-btn-primary"
							onClick={e => {
								e.preventDefault();
								e.stopPropagation();
								this.props.getCampaignData(fields.getAll(), offerId)
									.then((result) => {
										fields.push({
											campaign_lang: result.language,
											campaign_title: result.title,
											campaign_currency: result.currency,
											campaign_id: result.id,
											space_title: result.traffic_source
										});
									});
							}}
						>Add campaign payout</button>
				}
			</td>
		);
	}
}

const Targets = ({
	intl,
	filters,
	offer,
	offers,
	payoutMatrix,
	campaignPayouts,
	fields,
	payoutCurrencies,
	getCampaignData,
	defaultTerms,
	parentIndex,
	removeCampaignPayout,
	can,
	nullifiedBoosts,
	indTermsNullifyBoostOnSubmit,
	isMaster
}) => (
	<tr className="targeting-form__wrap">
		<td colSpan={5}>

			<table className="targeting-form__table">
				<thead className="targeting-form__table-head">
					<tr>
						{isMaster && (<th className='locked'><span>{intl('Locked')}</span></th>)}
						<th className="location"><span>{intl('Geo')}</span></th>
						<th className="left"><span>{intl('Cap')}</span></th>
						{isRocket
							? <th className="left"><span>{intl('Max aff payout')}</span></th>
							: <th className="left"><span>{intl('Payout spread')}</span></th>
						}
						{payoutCurrencies.map((currency, key) =>
							<th key={key} className="price"><span>{intl('Payout %s', `, ${currency}`)}</span></th>
						)}
					</tr>
				</thead>

				<tbody className="targeting-form__table-body">

					{fields.map((parentName, index, fields) => {
						const location = get(fields.get(index), 'location_id');
						const locationId = location[0]['value'];
						const offerId = get(fields.get(index), 'offer_id');
						const offerData = find(offers, { id: Number(offerId) }) || {};
						const paySpread = find(payoutMatrix, {
							niche: offerData.niche, sale_model: offerData.sale_model, country_id: Number(locationId)
						});
						const payoutSpreadMsg = paySpread
							? `${Number(paySpread.amount)}${paySpread.max_amount ? `-${Number(paySpread.max_amount)}` : ''}`
							: '';

						if (filters.country_ids) {
							if (!filters.country_ids.includes(locationId)) return;
						}

						const defaultTarget = getDefaultTarget(fields.get(index), defaultTerms[parentIndex]);

						const competencePercent = defaultTarget && parseInt(defaultTarget.competence_percent) || 0;
						const defaultAmount = defaultTarget && parseInt(defaultTarget.usd) || 0;

						const payoutDirection = getPayoutDirectionClassName(
							fields.get(index),
							defaultTarget,
							payoutCurrencies
						);
						const shouldDisablePayoutInputs = fields.get(index) &&
							(fields.get(index).status !== 'active' && !isNull(fields.get(index).amount));

						const wasBoostNullified = !!find(nullifiedBoosts, { offerId, locationId });
						const isCurrentlyBoosted = !wasBoostNullified && fields.get(index).boost_till !== null;

						return [(
							<tr
								className={fields.get(index) && fields.get(index).is_locked ? 'locked-row' : ''}
								key={2 * index}
							>
								{isMaster && (
									<td className='locked'>
										<Field
											name={`${parentName}.is_locked`}
											component={CheckboxField}
											normalize={Boolean}
										/>
									</td>
								)}
								<td className="location">
									<div className={cn('ui-form__element location__field',
										isCurrentlyBoosted ? 'boosted': '')}>
										<Field
											name={`${parentName}.location_id`}
											placeholder=''
											component={SelectField}
											disabled={true}
											searchable={false}
											multi={false}
											showLabel={false}
											options={[]} />
									</div>
								</td>
								<td className='cap'>
									<div className={cn('ui-form__element')}>
										<Field
											name={`${parentName}.cap`}
											placeholder=''
											component={InputField}
											disabled={!can('offersChangeCap') && !isRocket}
											showLabel={false} />
									</div>
								</td>
								{
									<td className='cap'>
										<div className={cn('ui-form__element')}>
											<InputField
												showLabel={false}
												meta={{}}
												disabled
												input={{
													value: isRocket
														? Math.round((100 + competencePercent) * defaultAmount / 100)
														: payoutSpreadMsg
												}}
											/>
										</div>
									</td>
								}
								{
									payoutCurrencies.map((curr, index) =>
										<td
											key={index}
											className={`price last ${fields.get(index) && fields.get(index).is_locked ? 'locked-row' : ''}`}
										>
											<div className={`ui-form__element payout-direction-${payoutDirection[curr]}`}>
												<Field
													name={`${parentName}.${curr}`}
													placeholder=""
													component={InputField}
													onChange={() => indTermsNullifyBoostOnSubmit({
														offerId, locationId, payoutPath: `${parentName}.${curr}`,
														isBoosted: isCurrentlyBoosted
													})}
													showLabel={false}
													disabled={shouldDisablePayoutInputs} />
											</div>
										</td>
									)
								}
								{/*<td className="actions">
									<span
										className="delete"
										onClick={() => {
											if (confirm(intl('Reset terms to default %s', '?'))) {
												onTermsResetToDefault(
												offer[0]['value'],
												locationId
											);
											}
										} }
									/>
								</td>*/}
							</tr>
						), (
							<tr key={2 * index + 1}>
								<FieldArray
									campaignPayouts={campaignPayouts}
									name={`${parentName}.campaigns`}
									removeCampaignPayout={removeCampaignPayout}
									getCampaignData={getCampaignData}
									payoutCurrencies={payoutCurrencies}
									offerId={offerId}
									defaultTermsByOffer={defaultTerms[parentIndex]}
									component={CampaignPayouts}
								/>
							</tr>
						)];
					})}
				</tbody>
			</table>
		</td>
	</tr>
);

const getPayoutDirectionClassName = (field, defaultTargetByLocation, payoutCurrencies) => {
	const calcDirection = currency => {
		const defaultAmount = defaultTargetByLocation && parseInt(defaultTargetByLocation[currency]) || 0;
		const savedAmount = field && parseInt(field[currency]) || 0;

		return savedAmount > defaultAmount ?
			'more' : savedAmount < defaultAmount ? 'less' : '';
	};

	return payoutCurrencies.reduce((acc, curr) => { acc[curr] = calcDirection(curr); return acc;}, {});
};

const getDefaultTarget = (field, { targets }) => {
	const fieldLocationId = field['location_id'] && field['location_id'][0]['value'];

	return find(targets, entity => entity['location_id'] && entity['location_id'][0]['value'] === fieldLocationId);
};

Targets.propTypes = propTypes;
export default Targets;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/profile/forms/individual-terms/targets.js